import Logo from "@/components/washflow/Logo";

export default function Footer() {
  return (
    <footer data-testid="footer-section" className="bg-[#2C3E50] py-10">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 flex flex-col sm:flex-row items-center justify-between gap-6">
        <div className="flex items-center gap-3">
          <Logo light badge={false} />
          <span className="text-xs text-[#AED6F1]">Powered by OpsIQ</span>
        </div>
        <nav className="flex flex-wrap justify-center gap-x-6 gap-y-2">
          <a href="#problem" className="text-sm text-[#AED6F1] hover:text-white transition-colors">The Problem</a>
          <a href="#solution" className="text-sm text-[#AED6F1] hover:text-white transition-colors">Solution</a>
          <a href="#pricing" className="text-sm text-[#AED6F1] hover:text-white transition-colors">Plans</a>
          <a href="#contact" className="text-sm text-[#AED6F1] hover:text-white transition-colors">Contact</a>
        </nav>
        <p className="text-sm text-[#7F8C9B]">&copy; 2026 OpsIQ &middot; Accra, Ghana</p>
      </div>
    </footer>
  );
}
